import { TYPES } from './constants';

export const columns = ({ t }) => [
  {
    title: t('Reference Label'),
    name: 'label'
  },
  // removing this column for now, may want to add it back in later if we determine we want to do something with this
  // {
  //   title: t('Placeholder Text'),
  //   name: 'description'
  // },
  {
    title: t('Field Type'),
    name: 'customFieldType'
  },
  {
    title: t('Required?'),
    name: 'required'
  },
  {
    title: t('Display?'),
    name: 'display'
  }
];

export const MockedData = [
  {
    referenceLabel: 'Reference E',
    placeholderText: '',
    fieldType: 'Multi-Select',
    required: 'No',
    display: 'Yes'
  },
  {
    referenceLabel: 'Reference A',
    placeholderText: 'Lorem ipsum dolor sit',
    fieldType: 'Single Select',
    required: 'Yes',
    display: 'Yes'
  },
  {
    referenceLabel: 'Reference C',
    placeholderText: 'Lorem ipsum dolor sit',
    fieldType: 'Text Input',
    required: 'No',
    display: 'Yes'
  },
  {
    referenceLabel: 'Reference B',
    placeholderText: '',
    fieldType: 'Multi-Select',
    required: 'No',
    display: 'Yes'
  },
  {
    referenceLabel: 'Reference D',
    placeholderText: 'Lorem ipsum dolor sit',
    fieldType: 'Text Input',
    required: 'Yes',
    display: 'Yes'
  }
];

export const formatData = items =>
  items.map(item => ({
    ...item,
    required: item.customFieldRequirementLevelId === 'ERROR' ? 'Yes' : 'No',
    display: item.customFieldVisibilityId === 'SHOW' ? 'Yes' : 'No',
    customFieldType: TYPES[item.customFieldTypeId],
    rowVersion: String(item.rowVersion),
    isNew: false
  }));

export default {
  columns,
  MockedData,
  formatData
};
